export const addresses = [
  {
    id: 1,
    userId: 1,
    name: 'Home',
    street: '123 Main Street',
    city: 'New York',
    state: 'NY',
    zipCode: '10001',
    country: 'USA',
    isDefault: true,
    phone: '+1234567890'
  },
  {
    id: 2,
    userId: 1,
    name: 'Work',
    street: '456 Business Ave',
    city: 'New York',
    state: 'NY',
    zipCode: '10002',
    country: 'USA',
    isDefault: false,
    phone: '+1234567890'
  }
];

export const getAddresses = (userId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const userAddresses = addresses.filter(a => a.userId === userId);
      resolve([...userAddresses]);
    }, 300);
  });
};

export const addAddress = (address) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newAddress = {
        id: addresses.length + 1,
        ...address,
        createdAt: new Date().toISOString()
      };
      addresses.push(newAddress);
      resolve(newAddress);
    }, 300);
  });
};

export const updateAddress = (id, updates) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = addresses.findIndex(a => a.id === id);
      if (index !== -1) {
        addresses[index] = { ...addresses[index], ...updates };
        resolve(addresses[index]);
      } else {
        reject(new Error('Address not found'));
      }
    }, 300);
  });
};

export const deleteAddress = (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = addresses.findIndex(a => a.id === id);
      if (index !== -1) {
        addresses.splice(index, 1);
        resolve(true);
      } else {
        reject(new Error('Address not found'));
      }
    }, 300);
  });
};